import React, { useState } from "react"
import ModalComponent from "./Modal"
import { Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import axiosProvider from "../lib/AxiosProvider"
import { admin } from "../config/apiEndpoints"
import { toast } from "react-toastify"
import { handleOnBlur, handleOnchange } from "../lib/GlobalMethods"

const ChangePassword = ({ show, modalsetShow }) => {
  const [passwordVisibility, setPasswordVisibility] = useState({
    old: false,
    new: false,
    confirm: false,
  })

  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    currentPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .required("Password is required!")
      .min(6, "Password should be 6 char minimum.")
      .max(16, "Password should be 16 char maximum.")
      .matches(/[a-zA-Z]/, "Password should contain at least one letter")
      .matches(/[^\w]/, "Password requires a symbol"),
    confirmPass: Yup.string()
      .required("Confirm Password is Required!")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  })

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: "PATCH",
        endpoint: admin.changePassword,
        data: values,
      })

      if (response?.data?.code === 200 || response?.data?.code === 201) {
        toast.success(response?.data?.message)
        setLoading(false)
        resetForm()
        handleClose()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPass: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { errors, values, touched, setFieldValue, resetForm } = formik

  const handleClose = () => {
    modalsetShow(false)
    resetForm()
  }

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        modeltitle={"Change Password"}
        backdrop={"static"}
        animationFade={true}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="white" />
          ) : (
            "Update"
          )
        }
        handleSubmit={formik?.handleSubmit}
        btnclosetext={"Close"}
        onHide={handleClose}
        children={
          <>
            <Form noValidate>
              <Row xs={"auto"}>
                <Col xs={12}>
                  <FloatingLabel
                    controlId="currentPassword"
                    label={
                      <>
                        Old Password <span className="required_star">*</span>
                      </>
                    }
                    className="mb-3 position-relative passwordicon_wrapper w-100"
                  >
                    <Form.Control
                      type={passwordVisibility.old ? "text" : "password"}
                      placeholder=""
                      name="currentPassword"
                      autoComplete="false"
                      maxLength={16}
                      onChange={(e) => handleOnchange(e, false, formik)}
                      onBlur={(e) => handleOnBlur(e, formik)}
                      isInvalid={
                        touched.currentPassword && errors.currentPassword
                      }
                      isValid={
                        touched.currentPassword && !errors.currentPassword
                      }
                    />
                    <i
                      className={`icon_main ${
                        passwordVisibility.old ? "eye_close" : "eye_open"
                      } `}
                      onClick={() => togglePasswordVisibility("old")}
                    ></i>
                    <Form.Control.Feedback type="invalid">
                      {errors.currentPassword}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
                <Col xs={12}>
                  <FloatingLabel
                    controlId="newPassword"
                    label={
                      <>
                        New Password <span className="required_star">*</span>
                      </>
                    }
                    className="mb-3 position-relative passwordicon_wrapper w-100"
                  >
                    <Form.Control
                      type={passwordVisibility.new ? "text" : "password"}
                      placeholder=""
                      name="newPassword"
                      autoComplete="false"
                      maxLength={16}
                      onChange={(e) => handleOnchange(e, false, formik)}
                      onBlur={(e) => handleOnBlur(e, formik)}
                      isInvalid={touched.newPassword && errors.newPassword}
                      isValid={touched.newPassword && !errors.newPassword}
                    />
                    <i
                      className={`icon_main ${
                        passwordVisibility.new ? "eye_close" : "eye_open"
                      } `}
                      onClick={() => togglePasswordVisibility("new")}
                    ></i>
                    <Form.Control.Feedback type="invalid">
                      {errors.newPassword}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
                <Col xs={12}>
                  <FloatingLabel
                    controlId="confirmPass"
                    label={
                      <>
                        Confirm Password{" "}
                        <span className="required_star">*</span>
                      </>
                    }
                    className="mb-3 position-relative passwordicon_wrapper w-100"
                  >
                    <Form.Control
                      type={passwordVisibility.confirm ? "text" : "password"}
                      placeholder=""
                      name="confirmPass"
                      autoComplete="false"
                      maxLength={16}
                      onChange={(e) => handleOnchange(e, false, formik)}
                      onBlur={(e) => handleOnBlur(e, formik)}
                      isInvalid={touched.confirmPass && errors.confirmPass}
                      isValid={touched.confirmPass && !errors.confirmPass}
                    />
                    <i
                      className={`icon_main ${
                        passwordVisibility.confirm ? "eye_close" : "eye_open"
                      } `}
                      onClick={() => togglePasswordVisibility("confirm")}
                    ></i>
                    <Form.Control.Feedback type="invalid">
                      {errors.confirmPass}
                    </Form.Control.Feedback>
                  </FloatingLabel>
                </Col>
              </Row>
            </Form>
          </>
        }
      />
    </>
  )
}

export default ChangePassword
